import { useAanbodExtensions } from '@/use/aanbod-definitie/use-aanbod-extensions';
import { useLeadAanvraagStore } from '@/stores/lead-aanvraag/lead-aanvraag';

export const useStartAanbod = () => {
  const { aanbodDefinitie, subflowVersies } = useAanbodExtensions(true);

  async function startAanbod() {
    const leadAanvraagStore = useLeadAanvraagStore();
    if (!aanbodDefinitie?.value) {
      throw new Error('Unable to start aanvraag without aanbodDefinitie');
    }

    await leadAanvraagStore.startAanbod(
      aanbodDefinitie.value.aanbodType,
      aanbodDefinitie.value.aanbodVersieId,
      subflowVersies.value
    );
  }

  return {
    startAanbod
  };
};
